import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const StakingResultModal = ({ result, onClose }) => {
  const { t } = useTranslation();

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  if (!result?.variant) return null;

  const isSuccess =
    result.variant === 'stake_success' || result.variant === 'unstake_request_success';

  const titleKey =
    result.variant === 'stake_success'
      ? 'staking.result_stake_success'
      : result.variant === 'stake_error'
        ? 'staking.result_stake_error'
        : result.variant === 'unstake_request_success'
          ? 'staking.result_unstake_success'
          : 'staking.result_unstake_error';

  const defaultTitle =
    result.variant === 'stake_success'
      ? 'Successful stake!'
      : result.variant === 'stake_error'
        ? 'Failed stake'
        : result.variant === 'unstake_request_success'
          ? 'Successful Un-Stake request!'
          : 'Failed Un-Stake request';

  const detail =
    result.detail === 'WALLET_REQUIRED'
      ? t('staking.wallet_required', 'Connect your wallet to continue.')
      : result.detail && result.detail !== 'WALLET_REQUIRED'
        ? result.detail
        : null;

  return (
    <div className="staking-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="staking-modal staking-result-modal"
        role="alertdialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="staking-modal-close" onClick={onClose} aria-label="Close">
          ×
        </button>
        <div className={`staking-result-icon ${isSuccess ? 'staking-result-icon--ok' : 'staking-result-icon--err'}`}>
          {isSuccess ? '✓' : '×'}
        </div>
        <p className="staking-result-label">
          {isSuccess ? t('staking.result_label_ok', 'Successful') : t('staking.result_label_err', 'Error')}
        </p>
        <p className="staking-result-title">{t(titleKey, defaultTitle)}</p>
        {detail ? (
          <p className={`staking-result-detail ${isSuccess ? 'staking-result-detail--muted' : ''}`}>
            {detail}
          </p>
        ) : null}
        <button type="button" className="staking-btn staking-btn-primary staking-btn-block" onClick={onClose}>
          {t('common.close', 'Close')}
        </button>
      </div>
    </div>
  );
};

export default StakingResultModal;
